import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
		min-width: 300px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	td:first-child {
		text-align: right;
	}

	td, th {
		border-right: 1px solid var(--og-border-color);
		border-bottom: 1px solid var(--og-border-color);
		width: 50%;
		padding: 4px;
	}

	tr:last-child td {
		border-bottom: none;
	}

	og-button {
		text-align: center;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}

	.header .agent-info {
		display: flex;
		align-items: center;
		min-width: 0;
		flex: 1;
		gap: 4px;
	}

	.header .agent-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		min-width: 0;
		flex: 1;
		width: 1px;
		font-weight: bold;
	}

	.header .agent-icon {
		display: flex;
		flex-shrink: 0;
	}

	.body .agent-buttons {
		display: flex;
		gap: 4px;
	}

	.body .agent-buttons .action {
		flex: 1;
	}
`;
